// import clevertap from "clevertap-web-sdk";
import { getCustomerID, getPhoneNo } from "../utils/storage";
import { getVisitType, getCustomerType } from "./script";
import { strEncryptionSHA256, getSelectedProductType } from "../utils/utils";

export async function profilePushIdentity(user) {
  const { customerID, mobile, dob, gender, name, email } = user;
  if (!window.clevertap) return;
  window?.clevertap?.onUserLogin?.push({
    Site: {
      Identity: customerID,
      Phone: `+91${mobile}`,
      UserID: customerID,
      UtmSourceUser: localStorage.getItem("utm_source") || "NA",
      Name: name || "NA",
      Email: email || "NA",
      Gender: gender || "NA",
      DOB: new Date(dob) || "NA",
      // optional fields
      "MSG-email": true, // Enable email notifications
      "MSG-push": true, // Enable push notifications
      "MSG-sms": true, // Enable sms notifications
      "MSG-whatsapp": true, // Enable WhatsApp notifications
    },
  });
}

const clevertapEventPush = async ({ eventName, categoryName, attributes, v2 = false }) => {
  if (!window.clevertap) return;
  let finalAttributes = !v2
    ? {
        platform: "website",
        utm_source: localStorage.getItem("utm_source") || "NA",
        utm_medium: "NA",
        utm_campaign: "NA",
        utm_term: "NA",
        utm_content: "NA",
        user_insider: 0,
        flag_prod: 2,
        event_type_1: "frontend",
        ...attributes,
      }
    : attributes;
  window?.clevertap?.event?.push(eventName, finalAttributes);
  // await createClevertapEvents(categoryName, eventName, finalAttributes);
};

// Select Loan Event
export const clevertap_sv_sel_your_loan = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ015",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "one page",
    loan_purpose: localStorage.getItem("loan_purpose") || "NA",
    employment_type: localStorage.getItem("employment_type") || "NA",
    payment_mode: localStorage.getItem("payment_mode") || "NA",
    salary_date: localStorage.getItem("salary_date") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_sel_your_loan", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_sel_your_loan_sel = async (attributes, eventName) => {
  const finalAttributes = {
    event_id: "LOJ017",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    event_type_2: "interactive",
    previous_screen: "one page",
    emi_plan: localStorage.getItem("emi_plan") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName, categoryName: "select_your_loan", attributes: finalAttributes });
};

export const clevertap_sel_your_loan_continue_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ018",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    event_type_2: "interactive",
    previous_screen: "one page",
    emi_plan: localStorage.getItem("emi_plan") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sel_your_loan_continue_clk", categoryName: "select_your_loan", attributes: finalAttributes });
};

//loan-approval
export const clevertap_sv_loanApproval = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ020",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "select loan",
    emi_plan: localStorage.getItem("emi_plan") || "NA",
    offer_type: localStorage.getItem("offer_type") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_loan_approved", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_loan_approved_back_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ021",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "select loan",
    emi_plan: localStorage.getItem("emi_plan") || "NA",
    offer_type: localStorage.getItem("offer_type") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_approved_back_clk", categoryName: "loan_approved", attributes: finalAttributes });
};

export const clevertap_sel_your_loan_upgrade_amount_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ022",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "select loan",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sel_your_loan_upgrade_amount_clk", categoryName: "select_your_loan", attributes: finalAttributes });
};

export const clevertap_loan_approved_continue_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ022",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "select loan",
    emi_plan: localStorage.getItem("emi_plan") || "NA",
    offer_type: localStorage.getItem("offer_type") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_approved_continue_clk", categoryName: "loan_approved", attributes: finalAttributes });
};

// Emandate Event
export const clevertap_sv_btmsld_emandate = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ053",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "bank details",
    ...attributes,
  };
  clevertapEventPush({ eventName: "btmsld_emandate", categoryName: "sv_btmsld", attributes: finalAttributes });
};

export const clevertap_btmsld_emandate_man_continue_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ054",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "bank details",
    ...attributes,
  };
  clevertapEventPush({ eventName: "btmsld_emandate_man_continue_clk", categoryName: "emandate", attributes: finalAttributes });
};

//Penny Drop Event
export const clevertap_sv_penny_drop = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ056",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "emandate",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_penny_drop", categoryName: "screen_view", attributes: finalAttributes });
};

// Add Bank Events

export const clevertap_sv_add_bank_details = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ047",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_add_bank_details", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_add_bank_details_act_num_filled = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ048",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "add_bank_details_act_num_filled", categoryName: "add_bank_details", attributes: finalAttributes });
};

export const clevertap_add_bank_details_re_act_num_filled = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ049",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "add_bank_details_re_act_num_filled", categoryName: "add_bank_details", attributes: finalAttributes });
};

export const clevertap_add_bank_details_ifsc_filled = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ050",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "add_bank_details_ifsc_filled", categoryName: "add_bank_details", attributes: finalAttributes });
};

export const clevertap_add_bank_details_submit_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ052",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "add_bank_details_submit_clk", categoryName: "add_bank_details", attributes: finalAttributes });
};

// kFS Verification Event
export const clevertap_sv_key_fct_stat = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ058",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "select loan",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_key_fct_stat", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_key_fct_stat_back_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ059",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "select loan",
    ...attributes,
  };
  clevertapEventPush({ eventName: "key_fct_stat_back_clk", categoryName: "key_fact_statment", attributes: finalAttributes });
};

export const clevertap_key_fct_stat_consent = async (attributes, eventName) => {
  const finalAttributes = {
    event_id: "LOJ060",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "select loan",
    ...attributes,
  };
  clevertapEventPush({ eventName, categoryName: "key_fact_statment", attributes: finalAttributes });
};

export const clevertap_key_fct_stat_accept_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ061",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "select loan",
    ...attributes,
  };
  clevertapEventPush({ eventName: "key_fct_stat_accept_clk", categoryName: "key_fact_statment", attributes: finalAttributes });
};

// One Page Loan Event

export const clevertap_sv_one_page = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ068",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "home",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_one_page", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_one_page_back_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ069",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "home",
    ...attributes,
  };
  clevertapEventPush({ eventName: "one_page_back_clk", categoryName: "one_page", attributes: finalAttributes });
};

export const clevertap_one_page_edit_sel = async (attributes, eventName) => {
  const finalAttributes = {
    event_id: "LOJ070",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "home",
    ...attributes,
  };
  clevertapEventPush({ eventName, categoryName: "one_page", attributes: finalAttributes });
};

export const clevertap_one_page_continue_clk = async (attributes, eventName) => {
  const finalAttributes = {
    event_id: "LOJ071",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "interactive",
    previous_screen: "home",
    ...attributes,
  };
  clevertapEventPush({ eventName: "one_page_continue_clk", categoryName: "one_page", attributes: finalAttributes });
};

// Selfie Event
export const clevertap_sv_selfie = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ043",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "loan approval",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_selfie", categoryName: "screen_view", attributes: finalAttributes });
};

// Camera Allow Event
export const clevertap_sv_allow_camera_permission = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ041",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "selfie",
    ...attributes,
  };
  clevertapEventPush({ eventName: "sv_allow_camera_permission", categoryName: "screen_view", attributes: finalAttributes });
};

export const clevertap_allow_camera_permission_allow_clk = async (attributes) => {
  const finalAttributes = {
    event_id: "LOJ041",
    phone_number: await strEncryptionSHA256(getPhoneNo()),
    visit_type: getVisitType(),
    customer_id: getCustomerID(),
    user_type: getCustomerType(),
    product_type: getSelectedProductType(),
    user_email: await strEncryptionSHA256(localStorage.getItem("email")),
    user_pancard: await strEncryptionSHA256(localStorage.getItem("pancard")),
    event_type_2: "non_interactive",
    previous_screen: "selfie",
    ...attributes,
  };
  clevertapEventPush({ eventName: "allow_camera_permission_allow_clk", categoryName: "allow_camera_permission", attributes: finalAttributes });
};

/*===============================================
 CleverTap Repeat Journey v2
===============================================*/

export const clevertap_pre_approved_pl_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "pre_approved_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_pre_approved_pl_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "pre_approved_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_details_pl_screen = async () => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "loan_details_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_details_pl_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_details_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_drow_down_approved_pl_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "drow_down_approved_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_drow_down_approved_pl_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "drow_down_approved_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_bank_confirmation_pl_screen = async () => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "bank_confirmation_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_bank_confirmation_pl_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "bank_confirmation_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_selfie_verification_success = async () => {
  const finalAttributes = {
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "Selfie_verification_success", attributes: finalAttributes, v2: true });
};

export const clevertap_KFS_pl_screen = async () => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "KFS_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_KFS_pl_screen_click = async () => {
  const finalAttributes = {
    action: "click",
    CTA: "I Accept",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "KFS_pl_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_disbursal_pl_success_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_disbursal_pl_success_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_disbursal_pl_success = async (attributes) => {
  const finalAttributes = {
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_disbursal_pl_success", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_repayment_lending_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    utm_source: localStorage.getItem("utm_source") || "NA",
    product: getSelectedProductType(),
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_repayment_lending_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_repayment_lending_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    CTA: "Reapy loan",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_repayment_lending_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_repayment_payment_summury__screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_repayment_payment_summury__screen", attributes: finalAttributes, v2: true });
};

export const clevertap_loan_repayment_payment_summury__screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    CTA: "Pay Now",
    ...attributes,
  };
  clevertapEventPush({ eventName: "loan_repayment_payment_summury__screen", attributes: finalAttributes, v2: true });
};

/*---------------------------------------------
 // ReKYC Events
---------------------------------------------*/
export const clevertap_address_confirmation_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_address_confirmation_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_Re_kyc_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Re_kyc_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_Re_kyc_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Re_kyc_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_Re_kyc_success = async (attributes) => {
  const finalAttributes = {
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Re_kyc_success", attributes: finalAttributes, v2: true });
};

export const clevertap_Re_kyc_failed = async (attributes) => {
  const finalAttributes = {
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Re_kyc_faild", attributes: finalAttributes, v2: true });
};

export const clevertap_New_address_confirmation_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    product: getSelectedProductType(),
    user_type: getCustomerType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "New_address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_New_address_confirmation_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "New_address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_Manual_address_confirmation_screen = async (attributes) => {
  const finalAttributes = {
    action: "page_view",
    user_type: getCustomerType(),
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Manual_address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_Manual_address_confirmation_screen_click = async (attributes) => {
  const finalAttributes = {
    action: "click",
    CTA: "continue",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };
  clevertapEventPush({ eventName: "Manual_address_confirmation_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_consent_preferences_screen = async () => {
  const finalAttributes = {
    action: "page_view",
    utm_source: localStorage.getItem("utm_source") || "NA",
  };
  clevertapEventPush({ eventName: "consent_preferences_screen", attributes: finalAttributes, v2: true });
};

export const clevertap_consent_preferences_screen_click = async (attributes = {}) => {
  const finalAttributes = {
    action: "click",
    utm_source: localStorage.getItem("utm_source") || "NA",
    ...attributes,
  };

  clevertapEventPush({
    eventName: "consent_preferences_screen",
    attributes: finalAttributes,
    v2: true,
  });
};

export const clevertap__citizenship_declaration_screen_FE = async () => {
  const finalAttributes = {
    action: "page_view",
    journey_type: "Repeat",
    declaration_status: "Pending",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };

  clevertapEventPush({ eventName: "citizenship_declaration_screen_FE", attributes: finalAttributes, v2: true });
};

export const clevertap__citizenship_declaration_accepted_FE = async () => {
  const finalAttributes = {
    declaration_status: "Accepted",
    journey_type: "Repeat",
    declaration_version: "V1",
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };

  clevertapEventPush({ eventName: "citizenship_declaration_accepted_FE", attributes: finalAttributes, v2: true });
};

export const clevertap__KFS_screen = async (cta = "Start VKYC") => {
  const finalAttributes = {
    action: "click",
    CTA: cta,
    product: getSelectedProductType(),
    utm_source: localStorage.getItem("utm_source") || "NA",
  };

  clevertapEventPush({ eventName: "KFS_screen", attributes: finalAttributes, v2: true });
};

export const clevertap__VKYC_session_launched = async (session_id) => {
  const finalAttributes = {
    customer_id: getCustomerID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",
    session_id: session_id,
    product: getSelectedProductType(),
  };

  clevertapEventPush({ eventName: "VKYC_session_launched", attributes: finalAttributes, v2: true });
};

export const clevertap__VKYC_retry_Initiated = async (session_id) => {
  const finalAttributes = {
    customer_id: getCustomerID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",
    session_id: session_id,
    product: getSelectedProductType(),
  };

  clevertapEventPush({ eventName: "VKYC_retry_Initiated", attributes: finalAttributes, v2: true });
};
